/** 网络断开场景的轻量插图，仅使用主题语义色。 */
export function NetworkErrorIllustration() {
  return (
    <svg
      aria-hidden
      className="request-failure-illustration"
      fill="none"
      viewBox="0 0 160 120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="request-failure-illustration__ground"
        height="8"
        rx="4"
        width="96"
        x="32"
        y="98"
      />
      <path
        className="request-failure-illustration__cloud"
        d="M52 58c0-11 9-20 20-20 8 0 15 5 18 12 9 1 16 9 16 18 0 10-8 18-18 18H54c-11 0-20-9-20-20 0-5 2-9 5-12 0-1 0-2 1-3 2-3 6-5 12-5Z"
      />
      <path
        className="request-failure-illustration__signal"
        d="M108 44v18M116 36v34M124 28v50"
        strokeLinecap="round"
        strokeWidth="4"
      />
      <path
        className="request-failure-illustration__slash"
        d="M98 34 132 68"
        strokeLinecap="round"
        strokeWidth="4"
      />
    </svg>
  );
}
